/** @todo Do we need to pass canvas? It's on the ref */

/**
 * @param {fabric.Canvas} canvas - the fabric canvas
 * @param {Object} config - vertex configuration
 * @param {'shape'|'image'|'text'} config.vertexType - The type of vertex being added
 */
export class BlueprintVertex {
  /** @todo would Promise.resolve() cause any issue? */
  loaded = null;

  constructor(canvas, { vertexType }) {
    // Shared, init
    this.canvas = canvas;
    this.vertexType = vertexType;

    // Implemented only by children
    /** @todo: If this is built well, ref should be private */
    this.ref = null;
  }

  render() {
    this.ref.set('dirty', true);
    this.canvas.requestRenderAll();
  }

  /**
   * Center the vertex (by moving it) in the current viewport
   */
  centerInViewport() {
    const { canvas } = this;
    const zoom = canvas.getZoom();

    this.setCenterPoint({
      x:
        fabric.util.invertTransform(canvas.viewportTransform)[4] +
        canvas.width / zoom / 2,
      y:
        fabric.util.invertTransform(canvas.viewportTransform)[5] +
        canvas.height / zoom / 2,
    });
  }

  /**
   * Get the vertex's center position
   * This is a method because getters/setters aren't inherited in JS
   * @returns {{ x: number, y: number }} point
   */
  getCenterPoint() {
    return this.ref.getCenterPoint();
  }

  /**
   * Position the vertex by it's center
   * This is a method because getters/setters aren't inherited in JS
   * @param {{ x: number, y: number }} point
   */
  setCenterPoint(point) {
    this.ref.setPositionByOrigin(point, 'center', 'center');
  }

  /** override on instance */
  clone() {
    return new BlueprintVertex(this.canvas, this.vertexType);
  }
}
